import { useQueryClient } from '@tanstack/vue-query'
import { onBeforeMount, onBeforeUnmount } from 'vue'
import { wsClient } from '#shared/api/ws-client'
import type { Alert } from '../model/alert'
import type { AlertsQueryData } from '../model/alerts-query-data'
import type { GetAlertsResponse } from '../model/get-alerts-response'
import { ALERTS_QUERY_KEY } from './alerts-query'

export function useDynamicAlertUpdates() {
  const queryClient = useQueryClient()

  const onNewAlert = (alert: Alert) => {
    queryClient.setQueryData(ALERTS_QUERY_KEY, (queryData: AlertsQueryData | undefined) => {
      if (!queryData) {
        queryData = {
          pageParams: [],
          pages: [],
        }
      }

      const currentUnreadCount = Math.max(...queryData.pages.map(page => page.unreadCount), 0)

      const newPageParams = [null, ...queryData.pageParams]
      const newPages: GetAlertsResponse[] = [
        {
          data: [alert],
          endCursor: alert.id.toString(),
          hasNextPage: true,
          status: 'ok',
          unreadCount: currentUnreadCount + 1,
        },
        ...queryData.pages.map(page => ({
          ...page,
          unreadCount: currentUnreadCount + 1,
        })),
      ]

      return {
        pageParams: newPageParams,
        pages: newPages,
      }
    })
  }

  onBeforeMount(() => {
    wsClient.on('alert', onNewAlert)
  })

  onBeforeUnmount(() => {
    wsClient.off('alert', onNewAlert)
  })
}
